<template>
    <transition name="fade-overlay">
        <div
            v-if="visible"
            class="fixed inset-0 z-500 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-overlay"
        >
            <tag-icon
                class="w-16 h-16 text-stack-primary origin-tag-eyelet animate-tag-swing"
            />
        </div>
    </transition>
</template>

<script>
import TagIcon from "@/components/icons/TagIcon.vue";

export default {
    name: "AppLoading",
    components: { TagIcon },
    data: () => ({
        visible: false
    })
};
</script>
